// src/i18n/en.js
// English translations - DO NOT MODIFY

const en = {
  // Navigation
  nav: {
    explorer: 'Explore',
    favorites: 'Favorites',
    voyages: 'Trips',
    messages: 'Messages',
    profile: 'Profile',
  },

  // Categories
  categories: {
    sejours: 'Short Stay',
    locations: 'Rentals',
    immobilier: 'Real Estate',
    parcelles: 'Land & Properties',
    services: 'Services',
  },

  // Section descriptions (home)
  sections: {
    premiumTitle: 'Featured listings',
    premiumDesc: 'Selected and highlighted',
    sejoursTitle: 'Short Stays',
    sejoursDesc: 'Hotels, furnished studios and rooms',
    locationsTitle: 'Long-term Rentals',
    locationsDesc: 'Apartments and houses per month',
    immobilierTitle: 'Land & Properties',
    immobilierDesc: 'Land and properties for sale',
    servicesTitle: 'Services',
    servicesDesc: 'Cleaning, moving, renovation',
    seeAll: 'See all',
  },

  // Home
  home: {
    title: 'Fynho',
    recentTitle: 'Recently viewed',
    recentDesc: 'Pick up where you left off',
    subtitle: 'Find Your New Home',
    heroTitlePart1: 'Find your',
    heroTitleHighlight: 'new home',
    heroSubtitle: 'Stays, rentals, land and services all across Cameroon.',
    searchPlaceholder: 'Search a neighborhood...',
   useLocation: 'Search nearby',
    featured: 'Featured listings',
    viewMap: 'Map',
    noResults: 'No results found',
    listing: 'listing',
    listings: 'listings',
    footerTagline: 'Find Your New Home',
  },

  // Listing
  listing: {
    price: 'Price',
    bedroom: 'Bedroom',
    bedrooms: 'Bedrooms',
    bathroom: 'Bathroom',
    bathrooms: 'Bathrooms',
    area: 'Area',
    capacity: 'Capacity',
    person: 'person',
    persons: 'persons',
    perNight: 'per night',
    perMonth: 'per month',
    perSquareMeter: 'per m²',
    amenities: 'Amenities',
    photos: 'Photos',
    description: 'Description',
    location: 'Location',
    contact: 'Contact',
    phone: 'Phone',
    whatsapp: 'WhatsApp',
    reserve: 'Reserve',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    share: 'Share',
    report: 'Report',
    viewOnMap: 'View on map',
    distance: 'at',
    distanceKm: 'km',
  },

  // Reservation
  reservation: {
    title: 'Request a reservation',
    fullName: 'Full name',
    phone: 'Phone or WhatsApp',
    email: 'Email',
    checkInDate: 'Check-in date',
    checkOutDate: 'Check-out date',
    numberOfGuests: 'Number of guests',
    message: 'Message (optional)',
    submit: 'Send request',
    success: 'Reservation sent successfully!',
    error: 'Error sending reservation',
    terms: 'I accept the terms of use',
  },

  // Admin
  admin: {
    dashboard: 'Dashboard',
    listings: 'Listings',
    reservations: 'Reservations',
    owners: 'Owners',
    users: 'Users',
    admins: 'Administrators',
    quartiers: 'Neighborhoods',
    types: 'Listing types',
    reviews: 'Reviews',
    reports: 'Reports',
    stats: 'Statistics',
    auditLogs: 'Audit logs',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    approve: 'Approve',
    reject: 'Reject',
    view: 'View',
    actions: 'Actions',
    status: 'Status',
  },

  // Status
  status: {
    draft: 'Draft',
    pending: 'Pending',
    published: 'Published',
    rejected: 'Rejected',
    disabled: 'Disabled',
    new: 'New request',
    contacted: 'Contacted',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    archived: 'Archived',
  },

  // Common messages
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    ok: 'OK',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    noData: 'No data',
    tryAgain: 'Try again',
    language: 'Language',
    theme: 'Theme',
    themeDark: 'Dark',
    themeLight: 'Light',
    settings: 'Settings',
    help: 'Help',
    support: 'Support',
    logout: 'Logout',
    all: 'All',
  },

  // Errors
  errors: {
    required: 'This field is required',
    invalidEmail: 'Invalid email',
    invalidPhone: 'Invalid phone number',
    minLength: 'Minimum {min} characters',
    maxLength: 'Maximum {max} characters',
    passwordMismatch: 'Passwords do not match',
    networkError: 'Network error. Check your connection.',
    serverError: 'Server error. Try again later.',
    notFound: 'Resource not found.',
    unauthorized: 'Authentication failed.',
    forbidden: 'Access denied.',
    validationError: 'Please check the entered data.',
  },

  // Neighborhoods (examples)
  quartiers: {
    bonapriso: 'Bonapriso',
    bastos: 'Bastos',
    akwa: 'Akwa',
    bonanjo: 'Bonanjo',
    douala: 'Douala',
    yaounde: 'Yaounde',
    bafoussam: 'Bafoussam',
    kumba: 'Kumba',
  },
};

export default en;